/*
 * bd-signature-discount.js — marktfähig (alle Sprachen/Währungen)
 * 1) Klick auf einen [data-copy-discount]-Button kopiert den Code,
 *    aktiviert ihn für den Checkout (/discount/CODE) und hängt ihn
 *    an den Warenkorb (/cart/update.js), damit der Rabatt im Drawer sichtbar ist.
 * 2) Liegt bereits ein Code im discount_code-Cookie (z. B. über einen
 *    /discount-Link), wird er automatisch an den Warenkorb gehängt.
 * 3) Im Quick-Cart-Drawer: "Du sparst"-Zeile (lokalisiert) + rabattierte
 *    Zeilenpreise, formatiert in der Warenkorb-Währung (Intl.NumberFormat).
 */

var SBD_ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

document.addEventListener('click', function (event) {
  const button = event.target.closest('[data-copy-discount]');
  if (!button) return;

  const code = button.getAttribute('data-code');
  if (!code) return;

  applyDiscount(code);

  const markCopied = function () {
    button.classList.add('is-copied');
    clearTimeout(button.copyResetTimeout);
    const delay = parseInt(button.getAttribute('data-reset-delay'), 10) || 2500;
    button.copyResetTimeout = setTimeout(function () {
      button.classList.remove('is-copied');
    }, delay);
  };

  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(code).then(markCopied).catch(function () {
      fallbackCopy(code, markCopied);
    });
  } else {
    fallbackCopy(code, markCopied);
  }
});

function applyDiscount(code) {
  // Checkout-Session (Cookie) — Markt-Root nutzen, damit Subfolder-Märkte (/en, /fr …) stimmen
  try {
    fetch(SBD_ROOT + 'discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {});
  } catch (error) {}
  // … und direkt an den Warenkorb, damit der Drawer den Rabatt zeigt.
  attachDiscountToCart(code);
}

function getDiscountCookie() {
  const match = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
  return match ? decodeURIComponent(match[1]) : null;
}

let lastAttachAt = 0;
function attachDiscountToCart(code) {
  const now = Date.now();
  if (now - lastAttachAt < 3000) return; // nicht in Schleifen laufen
  lastAttachAt = now;
  try {
    fetch(SBD_ROOT + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: code }),
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) { renderCartSavings(cart); })
      .catch(function () {});
  } catch (error) {}
}

/* ── Geld & Sprache, marktunabhängig ────────────────────────────── */

const SBD_CURRENCY_TOKENS = /(EUR|CHF|PLN|SEK|DKK|CZK|HUF|UAH|Kč|zł|kr|Ft|₴|[€$£])/gi;

function isMoneyText(text) {
  const t = String(text).trim();
  if (!/\d/.test(t)) return false;
  // Währungszeichen/-codes und Zahlzeichen entfernen — bleibt etwas übrig
  // (z. B. "Mengenrabatt"), ist es kein reiner Preis.
  const rest = t
    .replace(SBD_CURRENCY_TOKENS, '')
    .replace(/[\d.,'’  \s−-]/g, '');
  return rest === '';
}

/* Zahl aus beliebigem Format ziehen: "92,50€", "CHF 1'299.00", "1 299 kr", "1.299€" */
function parseMoneyLoose(text) {
  const match = String(text).match(/\d[\d.,'’   ]*\d|\d/);
  if (!match) return null;
  const num = match[0].replace(/['’   ]/g, '');
  const lastSep = Math.max(num.lastIndexOf(','), num.lastIndexOf('.'));
  let intPart, decPart = '';
  if (lastSep > -1 && num.length - lastSep - 1 <= 2) {
    intPart = num.slice(0, lastSep).replace(/[.,]/g, '');
    decPart = num.slice(lastSep + 1);
  } else {
    intPart = num.replace(/[.,]/g, '');
  }
  const cents = parseInt(intPart || '0', 10) * 100 + (decPart ? parseInt((decPart + '0').slice(0, 2), 10) : 0);
  return isNaN(cents) ? null : cents;
}

/* In Warenkorb-Währung und Seiten-Sprache formatieren */
function formatMoneyIntl(cents, currency) {
  const lang = document.documentElement.lang || 'de';
  const opts = { style: 'currency', currency: currency || 'EUR' };
  if (cents % 100 === 0) { opts.minimumFractionDigits = 0; opts.maximumFractionDigits = 0; }
  try {
    return new Intl.NumberFormat(lang, opts).format(cents / 100);
  } catch (error) {
    return (cents / 100).toFixed(2) + ' ' + (currency || '');
  }
}

function savingsLabel(code) {
  const lang = (document.documentElement.lang || 'de').slice(0, 2).toLowerCase();
  const map = {
    de: 'Du sparst mit ',
    en: 'You save with ',
    fr: 'Tu économises avec ',
    it: 'Risparmi con ',
    nl: 'Je bespaart met ',
    pl: 'Oszczędzasz z ',
    sv: 'Du sparar med ',
  };
  return (map[lang] || map.en) + code;
}

/* ── Anzeige im Drawer ──────────────────────────────────────────── */

/* Rabattierte Preise direkt an den Produktzeilen im Drawer anzeigen. */
function renderLineDiscounts(cart) {
  if (!cart || !cart.items) return;

  // Heilung: falls frühere Versionen Nicht-Preis-Elemente (z. B. das
  // Mengenrabatt-Badge) erwischt haben, zurückbauen.
  document.querySelectorAll('[data-sig-struck]').forEach(function (el) {
    if (!isMoneyText(el.textContent)) {
      el.style.textDecoration = '';
      el.style.opacity = '';
      el.removeAttribute('data-sig-struck');
      const sib = el.parentNode && el.parentNode.querySelector('[data-sig-price]');
      if (sib) sib.remove();
    }
  });

  const rows = document.querySelectorAll('[data-items] .quick-cart__item');
  if (!rows.length) return;

  const activeCode = (getDiscountCookie() || 'SIGNATURE').toLowerCase();

  // Zeilen nach Variant-ID einsammeln (mehrere Zeilen derselben Variante der Reihe nach zuordnen)
  const byId = {};
  rows.forEach(function (row) {
    const id = row.getAttribute('data-id');
    (byId[id] = byId[id] || []).push(row);
  });

  cart.items.forEach(function (item) {
    const list = byId[String(item.id)];
    const row = list && list.shift();
    if (!row) return;
    const priceEl = row.querySelector('.quick-cart__item-price');
    if (!priceEl) return;

    // Nur den Code-Rabatt umrechnen — automatische Rabatte (z. B. Mengenrabatt)
    // zeigt das Theme bereits selbst als Badge an.
    let discount = 0;
    (item.discounts || []).forEach(function (d) {
      if (String(d.title || '').toLowerCase() === activeCode) discount += d.amount || 0;
    });

    const existing = priceEl.querySelector('[data-sig-price]');
    if (!discount) {
      if (existing) {
        // Rabatt entfernt: unsere Anzeige zurückbauen
        existing.remove();
        const struck = priceEl.querySelector('[data-sig-struck]');
        if (struck) { struck.style.textDecoration = ''; struck.style.opacity = ''; struck.removeAttribute('data-sig-struck'); }
      }
      return;
    }
    if (existing && existing.getAttribute('data-sig-price') === String(discount)) return; // schon aktuell

    const base = item.final_line_price || item.line_price || 0;
    if (!base) return;
    const factor = Math.max(base - discount, 0) / base;

    // Letzten Span nehmen, der WIRKLICH ein Preis ist (bei Sale-Artikeln der
    // bereits reduzierte) — Badges wie „5€ Mengenrabatt“ werden übersprungen.
    const spans = Array.prototype.filter.call(
      priceEl.querySelectorAll('span:not([data-sig-price])'),
      function (el) { return isMoneyText(el.textContent); }
    );
    const current = spans.length ? spans[spans.length - 1] : null;
    if (!current) return;
    const shown = parseMoneyLoose(current.textContent);
    if (shown === null) return;

    if (existing) existing.remove();
    current.style.textDecoration = 'line-through';
    current.style.opacity = '0.55';
    current.setAttribute('data-sig-struck', '');

    const sig = document.createElement('span');
    sig.setAttribute('data-sig-price', String(discount));
    sig.style.cssText = 'font-weight:700;margin-left:6px;';
    sig.textContent = formatMoneyIntl(Math.round(shown * factor), cart.currency);
    current.parentNode.insertBefore(sig, current.nextSibling);
  });
}

function renderCartSavings(cart) {
  renderLineDiscounts(cart);
  const totalEl = document.querySelector('.quick-cart__total');
  if (!totalEl) return;

  // Nur die Ersparnis durch den Code summieren — automatische Rabatte
  // (z. B. Mengenrabatt) zeigt das Theme separat an.
  let discount = 0;
  if (cart && cart.items) {
    const activeCode = (getDiscountCookie() || 'SIGNATURE').toLowerCase();
    cart.items.forEach(function (item) {
      (item.discounts || []).forEach(function (d) {
        if (String(d.title || '').toLowerCase() === activeCode) discount += d.amount || 0;
      });
    });
  }

  let row = document.querySelector('[data-signature-savings]');

  if (!cart || !discount) {
    if (row) row.style.display = 'none';
    return;
  }

  const code = getDiscountCookie() || 'SIGNATURE';
  if (!row) {
    row = document.createElement('div');
    row.setAttribute('data-signature-savings', '');
    row.style.cssText = 'display:flex;justify-content:space-between;align-items:center;margin-top:6px;color:#658A50;';
    row.innerHTML = '<span class="paragraph-small" data-signature-savings-label></span>'
      + '<span class="paragraph-small" style="font-weight:700;" data-signature-savings-amount></span>';
    totalEl.parentNode.insertBefore(row, totalEl.nextSibling);
  }
  row.style.display = 'flex';
  row.querySelector('[data-signature-savings-label]').textContent = savingsLabel(code);
  row.querySelector('[data-signature-savings-amount]').textContent = '−' + formatMoneyIntl(discount, cart.currency);
}

function refreshCartSavings() {
  try {
    fetch(SBD_ROOT + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        const code = getDiscountCookie();
        // Code im Cookie, aber (noch) kein Rabatt am Warenkorb? Nachziehen.
        if (code && !cart.total_discount && cart.item_count > 0) {
          attachDiscountToCart(code);
          return;
        }
        renderCartSavings(cart);
      })
      .catch(function () {});
  } catch (error) {}
}

function initSignatureSavings() {
  const code = getDiscountCookie();
  if (code) attachDiscountToCart(code);

  // Immer wenn der Theme-JS Summe oder Produktzeilen neu rendert, Ersparnis nachziehen.
  // (Idempotenz-Check in renderLineDiscounts verhindert Endlosschleifen.)
  let debounce;
  const onMutate = function () {
    clearTimeout(debounce);
    debounce = setTimeout(refreshCartSavings, 250);
  };
  if (window.MutationObserver) {
    const subtotal = document.querySelector('[data-subtotal]');
    if (subtotal) new MutationObserver(onMutate).observe(subtotal, { childList: true, characterData: true, subtree: true });
    const items = document.querySelector('[data-items]');
    if (items) new MutationObserver(onMutate).observe(items, { childList: true, subtree: true });
  }
  refreshCartSavings();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSignatureSavings);
} else {
  initSignatureSavings();
}

function fallbackCopy(text, onSuccess) {
  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'fixed';
  textarea.style.opacity = '0';
  document.body.appendChild(textarea);
  textarea.select();

  try {
    document.execCommand('copy');
    onSuccess();
  } catch (error) {
    // Clipboard not available; silently ignore.
  }

  document.body.removeChild(textarea);
}
